import * as constants from "./InSilicoPredictionsConstants";
import * as urls from "./InSilicoPredictionsUrls";

export const metaScores = (inSilicoThresholds) => [
  {
    type: "dbItems",
    name: "MetaLR",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "metalr",
  },
  {
    type: "dbItems",
    name: "MetaSVM",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "metasvm",
  },
  {
    type: "dbItems",
    name: "MetaRNN",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "metarnn",
    url: urls.metaRnnUrl,
  },
  {
    type: "dbItems",
    name: "REVEL",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "revel",
    url: urls.revelUrl,
    thresholds: inSilicoThresholds,
  },
  {
    type: "dbItems",
    name: "BayesDel noAF",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "bayesdel_noaf",
    url: urls.bayesdelUrl,
  },
  {
    type: "dbItems",
    name: "BayesDel addAF",
    prediction: constants.PREDICTIONS_GROUP_1,
    prefix: "bayesdel_addaf",
    url: urls.bayesdelUrl,
  },
];
